import { ProductAttributes } from "@secureo/common/typings/ProductAttributes"

const hasAtLeastOneDimension = (dimensions: string[]) =>
	dimensions.reduce(
		(hasAtLeastOneDimension, dimension) => hasAtLeastOneDimension || !!dimension,
		false,
	)

const getDimensions = (width: any, height: any, depth: any) => {
	if (hasAtLeastOneDimension([width, height, depth]))
		return {
			width,
			height,
			depth,
		}

	return null
}

const getDimensionAttributes = (attributes: ProductAttributes) => {
	const { innerWidth, innerHeight, innerDepth, outerWidth, outerHeight, outerDepth } = attributes
	const innerDimensions = getDimensions(innerWidth, innerHeight, innerDepth)
	const outerDimensions = getDimensions(outerWidth, outerHeight, outerDepth)

	return {
		innerDimensions,
		outerDimensions,
	}
}

// The order of this array defines which attributes are rendered
const attributesToDisplay = [
	"fireSafetyGrade",
	"securityGrade",
	"Sicherheitslevel",
	"Systemtyp",
	"Patentlaufzeit",
	"Wendeschlüssel",
	"System",
	"Technologie",
	"Auflösung",
	"IR-Nachtsicht",
	"Kanäle",
	"Max. Speicher",
	"numberOfWeaponFixtures",
	"numberOfKeyHooks",
	"Brandklassen",
	"Löschmittel",
	"Inhalt",
	"weightKg",
	"Material",
	"color",
	"volumeLiter",
	"Dornmaß in mm",
	"Lochung",
	"Stulpform",
	"Vierkantmaß in mm",
	"Bedienung",
	"Zertifikat",
]

const filterAttributes = (attributes: ProductAttributes) => {
	const filteredAttributeKeys = Object.keys(attributes).filter((attributeKey) =>
		attributesToDisplay.includes(attributeKey),
	)

	const filteredAttributes = filteredAttributeKeys.reduce((filteredAttributes, attributeKey) => {
		return {
			...filteredAttributes,
			[attributeKey]: attributes[attributeKey],
		}
	}, {})

	return filteredAttributes
}

const getProductAttributes = (attributes: any) => {
	const { innerDimensions, outerDimensions } = getDimensionAttributes(attributes)
	const numberOfDimensionAttributes = [innerDimensions, outerDimensions].filter(
		(dimension) => !!dimension,
	).length

	const remainingFormattedAttributes = filterAttributes(attributes)
	const formattedAttributes = Object.entries(remainingFormattedAttributes)
		.map(([key, value]) => ({ key, value }))
		.slice(0, 5 - numberOfDimensionAttributes)

	return {
		innerDimensions,
		outerDimensions,
		formattedAttributes,
	}
}

export default getProductAttributes
